module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_EcuadorArg.efb46fe0.jpg";